const reportWebVitals = (onPerfEntry?: any) => {
  // Skip web vitals reporting if onPerfEntry is not provided
  // or if we're in a development environment without the package
  if (onPerfEntry && typeof onPerfEntry === 'function') {
    console.log('Web Vitals reporting is disabled. Install the web-vitals package to enable it.');
    // The web-vitals package is missing, but we don't want the app to crash
  }
};

export default reportWebVitals;
